import axios from 'axios';

// Public API without auth interceptors
const API_URL = process.env.REACT_APP_API_URL || '/api';

const publicApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default publicApi;
